import Chat from "./Chat"
import ChatInput from "./ChatInput";
import axios from 'axios';
import {useState, useEffect} from "react";
import config from '../config'

const ChatOwnClothesDisplay = ({user,clickedUser, clickedClothes}) => {
    const userId = user?.user_id
    const clickedInterestedUserId = clickedUser?.user_id
    const clickedClothesId = clickedClothes?._id
    const [usersMessages, setUsersMessages] = useState(null)
    const [clickedUsersMessages, setClickedUsersMessages] = useState(null)
    const [otherUser, setOtherUser] = useState(null)

    const getUsersMessages = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}messages`, {
                headers: {"token": localStorage.getItem("token")},
                params: {userId: userId, correspondingUserId: clickedInterestedUserId, 
                        clickedClothesId: clickedClothesId
                }
            })
            setUsersMessages(response.data)
        }
        catch(error){
            console.log(error)
        }

    }
    const getClickedUsersMessages = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}messages`, {
                headers: {"token": localStorage.getItem("token")},
                params: {userId: clickedInterestedUserId, correspondingUserId: userId,
                        clickedClothesId: clickedClothesId
                }
            })
            setClickedUsersMessages(response.data)
        }
        catch(error){
            console.log(error)
        }
    }
    const getOtherUser = async () => {
        try{
            const response = await axios.get(`${config.apiUrl}user`,{
                headers: {"token": localStorage.getItem("token")},
                params: {userId: clickedInterestedUserId}
            })
            setOtherUser(response.data)
        }
        catch(error){
            console.log(error)
        }
    }
    useEffect(()=>{
        getUsersMessages()
        getClickedUsersMessages()
        getOtherUser()
    }, [clickedUsersMessages, ])

    const messages = []

    usersMessages?.forEach(message =>{
        const formattedMessage = {}
        formattedMessage['img'] = message.img
        formattedMessage['message'] = message.message
        formattedMessage['from_userId'] = message.from_userId
        formattedMessage['timestamp'] = message.timestamp
        messages.push(formattedMessage)
    })

    clickedUsersMessages?.forEach(message =>{
        const formattedMessage = {}
        formattedMessage['img'] = message.img
        formattedMessage['message'] = message.message
        formattedMessage['from_userId'] = message.from_userId
        formattedMessage['timestamp'] = message.timestamp
        messages.push(formattedMessage)

    })
    const descendingOrderMessages = messages?.sort((a,b) => a.timestamp.localeCompare(b.timestamp))

    return(
        <>
        <Chat descendingOrderMessages={descendingOrderMessages} user={user} otherUser={otherUser}/>
        <ChatInput
            user={user}
            otherUserId={clickedInterestedUserId}
            clickedClothesId={clickedClothesId}
        />
        </>
    )
}
export default ChatOwnClothesDisplay